import React from 'react';

import { Box } from '@mui/material';

import { VerifiersPageWrapperClearVerifyAdmin } from 'src/components/verifier';
import {
  VerifierVerifyAutomaticByCVStaffModal,
  VerifierVerifyManuallyByCVStaffModal,
} from 'src/modals/verifier';
import { InviteVerifiersAdminsByCVAdminModal } from 'src/modals/verifierStaff';
import { TableDataProvider } from 'src/providers/TableDataProvider';
import { SxProp } from 'src/types/mui';

export const VerifiersPageClearVerifyAdmin: React.FC = () => {
  return (
    <React.Fragment>
      <Box sx={containerStyles}>
        <TableDataProvider>
          <VerifiersPageWrapperClearVerifyAdmin />
        </TableDataProvider>
      </Box>

      <InviteVerifiersAdminsByCVAdminModal />
      <VerifierVerifyAutomaticByCVStaffModal />
      <VerifierVerifyManuallyByCVStaffModal />
    </React.Fragment>
  );
};

const containerStyles: SxProp = {
  display: 'flex',
  flexGrow: 1,
  flexShrink: 1,
  flexBasic: '0%',
  flexDirection: 'column',
  height: '100%',
};
